// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Util_Array = require("../../util/Util_Array.bs.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var Organism_Dropdown = require("../organism/dropdown/Organism_Dropdown.bs.js");

function Atom_Select$Internal(Props) {
  var name = Props.name;
  var items = Props.items;
  var value = Props.value;
  var onChange = Props.onChange;
  var onBlur = Props.onBlur;
  var autoCompleteOpt = Props.autoComplete;
  var variant = Props.variant;
  var iconColor = Props.iconColor;
  var id = Props.id;
  var autoComplete = autoCompleteOpt !== undefined ? autoCompleteOpt : "off";
  var items$1 = Util_Array.NonEmpty.makeFromArray(items);
  if (items$1 === undefined) {
    return null;
  }
  var tmp = {
    kind: {
      TAG: /* Select */0,
      _0: {
        name: name,
        title: undefined,
        autoComplete: autoComplete,
        variant: variant
      }
    },
    items: Caml_option.valFromOption(items$1),
    onChange: onChange
  };
  if (value !== undefined) {
    tmp.value = Caml_option.valFromOption(value);
  }
  if (onBlur !== undefined) {
    tmp.onBlur = Caml_option.valFromOption(onBlur);
  }
  if (iconColor !== undefined) {
    tmp.iconColor = Caml_option.valFromOption(iconColor);
  }
  if (id !== undefined) {
    tmp.id = id;
  }
  return React.createElement(Organism_Dropdown.make, tmp);
}

var Internal = {
  make: Atom_Select$Internal
};

function Atom_Select$Mona(Props) {
  var name = Props.name;
  var items = Props.items;
  var value = Props.value;
  var onChange = Props.onChange;
  var autoCompleteOpt = Props.autoComplete;
  var variantOpt = Props.variant;
  var autoComplete = autoCompleteOpt !== undefined ? autoCompleteOpt : "off";
  var variant = variantOpt !== undefined ? variantOpt : "mona";
  var tmp = {
    name: name,
    items: items,
    onChange: onChange,
    autoComplete: autoComplete,
    variant: variant
  };
  if (value !== undefined) {
    tmp.value = Caml_option.valFromOption(value);
  }
  return React.createElement(Atom_Select$Internal, tmp);
}

var Mona = {
  make: Atom_Select$Mona
};

function Atom_Select$Presse(Props) {
  var name = Props.name;
  var items = Props.items;
  var value = Props.value;
  var onChange = Props.onChange;
  var onBlur = Props.onBlur;
  var autoCompleteOpt = Props.autoComplete;
  var variantOpt = Props.variant;
  var iconColorOpt = Props.iconColor;
  var id = Props.id;
  var autoComplete = autoCompleteOpt !== undefined ? autoCompleteOpt : "off";
  var variant = variantOpt !== undefined ? variantOpt : "presse";
  var iconColor = iconColorOpt !== undefined ? iconColorOpt : "Text";
  var tmp = {
    name: name,
    items: items,
    onChange: onChange,
    autoComplete: autoComplete,
    variant: variant,
    iconColor: iconColor
  };
  if (value !== undefined) {
    tmp.value = Caml_option.valFromOption(value);
  }
  if (onBlur !== undefined) {
    tmp.onBlur = Caml_option.valFromOption(onBlur);
  }
  if (id !== undefined) {
    tmp.id = id;
  }
  return React.createElement(Atom_Select$Internal, tmp);
}

var Presse = {
  make: Atom_Select$Presse
};

exports.Internal = Internal;
exports.Mona = Mona;
exports.Presse = Presse;
/* react Not a pure module */
